import React, { useState } from "react";
import DatePicker from "react-datepicker";
import { Locale } from "react-datepicker/dist/date_utils";
import classNames from "classnames";
import ru from "date-fns/locale/ru";
import { DateTime } from "luxon";
import CancelMaterialIcon from "@components/Svg/CancelMaterialIcon";
import { dateKeyBoardPattern } from "@src/utils/utils";
import { DatePickerInputProps } from "./date-picker-input.props";
import "react-datepicker/dist/react-datepicker.css";
import classes from "./date-picker-input.module.scss";

const ruLocale = ru as unknown as Locale;

const DatePickerInput = ({
    label,
    onChange,
    value,
    style,
    disabled,
    maxLength,
    customButton,
    onCustomButtonClick
}: DatePickerInputProps) => {
    const [isFocused, setIsFocused] = useState(false);

    const parsedValue =
        typeof value === "string" && DateTime.fromFormat(value, "dd.MM.yyyy").isValid
            ? DateTime.fromFormat(value, "dd.MM.yyyy").toJSDate()
            : null;

    const onChangeHandler = (date: Date | null) =>
        onChange?.(date ? DateTime.fromJSDate(date).toFormat("dd.MM.yyyy") : null);

    const showCancelButton = !customButton && value && !disabled;

    return (
        <div
            onKeyDown={(e) => {
                if (e.key === "Enter") {
                    onCustomButtonClick?.(e);
                }
            }}
            style={style}
            className={classes.MaterialTextInput}
        >
            <div className={classes.InputCont}>
                <div className="customDatePickerWidth">
                    <DatePicker
                        popperPlacement="bottom-start"
                        onChange={onChangeHandler}
                        showPopperArrow={false}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                        selected={parsedValue}
                        dateFormat="dd.MM.yyyy"
                        locale={ruLocale}
                        customInput={
                            <input
                                maxLength={maxLength}
                                type={"text"}
                                pattern={dateKeyBoardPattern}
                                inputMode={"numeric"}
                                id="fname"
                                name="fname"
                                aria-labelledby="placeholder-fname"
                                autoComplete={"off"}
                                style={{
                                    width: "100%"
                                }}
                            />
                        }
                    />

                    <label className={classNames(classes.PlaceholderText)} id="placeholder-fname">
                        <div
                            className={classNames(classes.Text, {
                                [classes.FocusedLabel]: isFocused || !!value
                            })}
                        >
                            {label}
                        </div>
                    </label>
                </div>
            </div>
            {customButton && (
                <div
                    className={classes.CustomButton}
                    onClick={(e) => onCustomButtonClick && onCustomButtonClick(e)}
                >
                    {customButton}
                </div>
            )}
            {showCancelButton && (
                <CancelMaterialIcon
                    onClick={() => {
                        onChange?.(null);
                    }}
                />
            )}
        </div>
    );
};
export default DatePickerInput;